import { Breadcrumbs, Icon, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";

type AccountBreadcrumbsProps = {
  label: string;
};

export function AccountBreadcrumbs(props: AccountBreadcrumbsProps) {
  return (
    <Breadcrumbs
      aria-label="AccountBreadcrumbs"
      separator={
        <Icon className={"ri-arrow-right-s-line"} sx={{ fontSize: "medium" }} />
      }
    >
      <NavLink style={{ textDecoration: "none" }} to="/account">
        <Typography color="secondary.main">Account</Typography>
      </NavLink>
      <Typography color="text.primary">{props.label}</Typography>
    </Breadcrumbs>
  );
}
